import { LitElement, PropertyValues, css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { FluxAnimation } from '../lib/flux-animation.js';

@customElement('c-flux')
export class CFlux extends LitElement {
  static styles = css`
    :host {
      display: block;
      opacity: 0;
      transition: opacity 0.8s ease-in-out;
    }

    canvas {
      width: 100%;
      height: 200px;
      display: block;
    }

    hgroup {
      h1 {
        color: var(--sl-color-neutral-700);
      }

      color: var(--sl-color-neutral-600);
      text-align: center;

      & > * {
        margin: 0 0 0.1em;
      }
    }


  `;

  @property({ type: Number }) totalFlux = null;
  @property({ type: Number }) normalizedFluxOffset = 0;
  @property({ type: String }) totalFluxHuman = '';
  @state() mainColor = 'hsl(0, 100%, 50%)';

  connectedCallback() {
    super.connectedCallback();
  }

  disconnectedCallback(): void {
    this.fluxAnimation?.destroy();
  }

  firstUpdated(_changedProperties) {
    super.firstUpdated(_changedProperties);

    this.setupAnimation();
  }

  protected willUpdate(_changedProperties): void {
    super.willUpdate(_changedProperties);

    if (_changedProperties.has('normalizedFluxOffset')) {
      console.log('Updating flux animation with totalFlux:', this.totalFlux);
      if (!this.fluxAnimation) return;

      this.fluxAnimation.fluxStrength = this.normalizedFluxOffset;
    }
  }

  get canvas() {
    return this.shadowRoot?.querySelector('canvas');
  }

  get fluxName() {
    const { normalizedFluxOffset } = this;
    if (normalizedFluxOffset > 0) {
      return 'Ahead';
    } else if (normalizedFluxOffset < 0) {
      return 'Behind';
    }
    return 'In Flux';
  }

  setupAnimation() {
    console.log('Canvas:', this.canvas, 'normalizedFluxOffset:', this.normalizedFluxOffset);
    this.fluxAnimation = new FluxAnimation({
      canvas: this.canvas,
      fluxStrength: this.normalizedFluxOffset,
    });

    this.fluxAnimation.onDraw = () => {
      this.mainColor = this.fluxAnimation.mainColor;
    };

    setTimeout(() => {
      this.fluxAnimation.start();
    }, 0);

    setTimeout(() => {
      this.style.opacity = '1';
    }, 16);

  }

  renderFluxStatus() {
    const ahead = "Good job, you created a bonus time for rainy days!";
    const behind = "Don't worry, you can catch up!";
    const inFlux = "You are in balance with your plan!";

    if (this.normalizedFluxOffset > 0) return ahead;
    else if (this.normalizedFluxOffset < 0) return behind;

    return inFlux;
  }

  render() {
    return html`
      <canvas height="200"></canvas>
      <hgroup style="--main-color: ${this.mainColor}">
        <h1>
          ${this.normalizedFluxOffset !== 0
          ? html`<span class="time">${this.totalFluxHuman}</span>`
          : ''}
          ${this.fluxName}
        </h1>
        <p class="desc">${this.renderFluxStatus()}</p>
      </hgroup>
    `;
  }
}

